import FullSizeVideoBlock from './FullSizeVideoBlock'

export default FullSizeVideoBlock
